module.exports = __webpack_public_path__ + "assets/img/stage-ccadb714.png";